import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import { MntProductsRoutingModule } from "./mnt-products-routing.module";
import { ListingComponent } from "./listing/listing.component";
import { MntMasterModule } from "../mnt-master/mnt-master.module";
import { AppMaterialModule } from "../app-material/app-material.module";
import { SharedModule } from "../shared/shared.module";

import {
  MatInputModule,
  MatTableModule,
  MatToolbarModule
} from "@angular/material";

import { FlashMessagesModule } from "angular2-flash-messages";
import { ViewProductComponent } from './view-product/view-product.component';
import { OrderQueueComponent } from './order-queue/order-queue.component';
import { CustomeLineitemComponent } from './custome-lineitem/custome-lineitem.component';
import { CustomeLineitemListComponent } from './custome-lineitem-list/custome-lineitem-list.component';
import { AddProductComponent } from './add-product/add-product.component';
import { AddCategoryComponent } from './add-category/add-category.component';
import { AddStyleComponent } from './add-style/add-style.component';
import { AddBrandComponent } from './add-brand/add-brand.component';
import { AddColorComponent } from './add-color/add-color.component';
import { AddFitsComponent } from './add-fits/add-fits.component';
import { AddGroupComponent } from './add-group/add-group.component';
import { CustomListingComponent } from './custom-listing/custom-listing.component';
import { RemoveSizeComponent } from './remove-size/remove-size.component';
import { AddColorRowComponent } from './add-color-row/add-color-row.component';
import { UploadColorImageComponent } from './upload-color-image/upload-color-image.component';
import { AddSizeComponent } from './add-size/add-size.component';
import { CreateSizeComponent } from './create-size/create-size.component';
import { SanmarListingComponent } from './sanmar-listing/sanmar-listing.component';
import { AlphabroderListingComponent } from './alphabroder-listing/alphabroder-listing.component';
import { QuickItemsComponent } from './quick-items/quick-items.component';
import { EditQuickItemComponent } from './edit-quick-item/edit-quick-item.component';


@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    MatToolbarModule,
    MatInputModule,
    MatTableModule,
    MntProductsRoutingModule,
    FlashMessagesModule,
    MntMasterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [CommonModule, MatToolbarModule, MatInputModule, MatTableModule],
  declarations: [ListingComponent, ViewProductComponent, OrderQueueComponent, CustomeLineitemComponent, CustomeLineitemListComponent, AddProductComponent, AddCategoryComponent, AddStyleComponent, AddBrandComponent, AddColorComponent, AddFitsComponent, AddGroupComponent, CustomListingComponent, RemoveSizeComponent, AddColorRowComponent, UploadColorImageComponent, AddSizeComponent, CreateSizeComponent, SanmarListingComponent, AlphabroderListingComponent, QuickItemsComponent, EditQuickItemComponent],
  entryComponents:[CreateSizeComponent,AddCategoryComponent,AddStyleComponent,AddBrandComponent,AddColorComponent,AddFitsComponent,AddGroupComponent,RemoveSizeComponent,AddColorRowComponent,UploadColorImageComponent]
})
export class MntProductsModule {
  AddCategoryComponent
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/mnt-products.module.ts